<template lang="pug">
section.src-components-hello-world
  //v-app-bar(app color="indigo darken-2" dark)
    nav
      v-btn(icon @click="$router.go(-1)") #[v-icon mdi-arrow-left]   
      router-link.ma-2(to="/")
        v-icon mdi-home 
        span.ma-2 Cajas      
    v-app-bar-title Ventas 
    v-spacer
    v-btn(@click="getVentas()" color="secondary" dark small) #[v-icon mdi-update] Actualizar
    v-btn.ma-2.mx-2(fab dark small color="teal" :disabled="loading" @click="excel()") #[v-icon(dark) mdi-microsoft-excel]
    //v-btn(icon @click="print()") #[v-icon mdi-printer]  
  v-progress-linear(:active='loading' :indeterminate='loading' absolute='' color='teal accent-4')
  v-card.ma-2
    v-card-title
      v-text-field(v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details)
    v-data-table.elevation-1(
      sort-by="fecha"
      :search="search" 
      dense 
      :expanded.sync="expanded"
      :headers="headers" 
      :items="ventas" 
      item-key="idventa"
      show-expand
      disable-pagination=true
      hide-default-footer=true
      @item-expanded="loadDetails"
      @current-items="currentItems($event)")
      template(v-slot:item.mozo="{item}")
        span {{ item.nromozo }} - {{item.mozo}}    
      template(v-slot:item.total="{item}")
        span {{ $formatNumber(item.total)}}
      template(v-slot:item.actions="{item}")
        //v-icon(v-if="editable&&!item.pagomultiple" small class="mr-2" @click="editItem(item)") mdi-pencil
      template(v-slot:expanded-item="{ headers, item }")
        td(:colspan="headers.length" )
          v-simple-table.mt-2(dense style="background-color:#EFEBE9;")
            thead
              th Hora
              th Cantidad
              th Concepto
              th PUni
              th Importe  
            tbody
              tr(v-for="(it,key) of item.detalleVentas" :key="it.idventadetail")
                td {{$formatTime(it.hora)}}
                td {{it.Cantidad}} 
                td {{it.NombreArticulo}}       
                td {{$formatNumber(it.monto)}}
                td {{$formatNumber(it.Cantidad * it.monto)}} 
          span Id Registro: {{item.idventa}} 
          span(v-if="item.isModifiedByIDVenta") Id Reemplazo: {{ item.isModifiedByIDVenta }}
          //comandas
          v-expansion-panels.mb-4.mt-4(accordion)
            v-expansion-panel(@click="clickComanda(item)")
              v-expansion-panel-header Comandas
              v-expansion-panel-content
                v-simple-table.mt-2(dense style="background-color:#EFEBE9;")
                  thead
                    th Nro
                    th Hora
                    th Cantidad
                    th Concepto
                    th PUni
                    th Importe  
                    th Equipo
                    th Impresora  
                  tbody
                    tr(v-for="(co,key) of item.comandas" :key="co.id")
                      td {{co.NROCOMANDA}}
                      td {{$formatTime(co.fechahora)}}
                      td {{co.CANTIDAD}} 
                      td {{co.NOMBREPRODUCTO }} {{ co.ONSERVACIONES }}
                      td {{$formatNumber(co.IMPORTE)}}
                      td {{$formatNumber(co.CANTIDAD * co.IMPORTE)}} 
                      td {{co.EQUIPO}}
                      td {{co.IMPRESORA}}

  h3 Total Visible: {{ suma }}
              
  Dialog(:medios="medios" :venta="venta" :dialog="dialog" 
  @save="dialog=false" @close="dialog=false" @cambiamp="cambiamp($event)" @partido="partido()")
</template>

<script lang="js">
  import Dialog from "./CambiaFP"
  import {Ventas} from "../db/Ventas"
  import { EventBus } from '../event-bus';
  export default  {
    name: 'src-components-hello-world',
    props: [],
    components:{ Dialog },
    mounted () {
      this.idcaja = this.$route.params.idcaja
      this.editable = true //this.$route.params.estado==1
      this.getVentas()
      EventBus.$off('toolbar_click')
      EventBus.$on('toolbar_click',(event)=>{
        switch(event) {
          case "update":
            this.dbventas = Ventas(this)
            this.getVentas()
            break;
          case "excel": {
            this.excel()
            break;
          }
        }

      });
    },
    data () {
      return {
        dbventas:Ventas(this),
        editable:false,
        idcaja:0,
        search:"",
        loading:true,
        ventas:[],
        dialog:false,
        venta:{},
        medios:[],
        itemsVisibles:[],
        detalleVentas:[],
        expanded:[],
        estados:['nada','abierto','cerrado','anulado'],
        headers: [
          { text: 'ID', value: 'idventa' , align: ' d-none'}, //permite buscar por id pero no muestra la columna
          { text: 'Fecha', value: 'fecha' },
          { text: 'Mesa/Pedido', value: 'smesa' },
          { text: 'T/F', value: 'TIPOFACTURA', align: 'end' },
          { text: 'Comprobante', value: 'NUMEROTICKET', align: 'end' },
          { text: 'Total', value: 'total', align: 'end' },
          { text: 'Anulado', value: 'anulado', align: 'end' },
          { text: 'Cuit', value: 'FIS_NRODOC' },
          { text: 'Cliente', value: 'nombres' },
          { text: 'Mozo/Repartidor', value: 'mozo' },
          { text: 'Medio de Pago', value: 'pagoL2t' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],    
        headersDetalle: [
          { text: 'Cant', value: 'Cantidad' },
          { text: 'Concepto', value: 'NombreArticulo' },
          { text: 'P.Uni.', value: 'monto', align: 'end' },
          { text: 'Total', value: 'total', align: 'end' },
          { text: 'Mozo', value: 'mozo' }, 
        ],               
      }
    },
    methods: {
      clickRow(item, event) {
        console.log(event)
        if(event.isExpanded) {
          const indexExpanded = this.expanded.findIndex(i => i === item);
          this.expanded.splice(indexExpanded, 1)
        } else {
          this.expanded.push(item);
          this.loadDetails({item})
        }
      },
      totalEstado(item) {
        if (item.estado==3 && item.isModifiedByIDVenta!=null) return `Reemplazado (${this.$formatNumber(item.total)})`
        if (item.estado==3) return `Anulado (${this.$formatNumber(item.total)})`
        return this.$formatNumber(item.total)
      },
      partido() {
        alert("todavia no programado")
      },
      print() {
        window.ipcRenderer.invoke('print').then(() => {
        }).catch((err) => {alert(err)})
      },
/*      cambiomodi(item) {
        window.ipcRenderer.invoke('sqlQuery',`update ventas set tipofactura = 'X', numeroticket = 0 where idventa = ${item.idventa}`)
        .then(()=>{
          item.TIPOFACTURA = 'X'
          item.NUMEROTICKET = 0
          alert("cambiado")
        }).catch((err)=>alert(err))
      },*/
      async cambiamp(medio) {
        let venta = this.venta
        if (venta.tipo>9) {
          alert("No se puede modificar este elemento")
          return
        }
        this.dialog = false        
        let sql = `update ventas set tipo = ${medio.tipoL1}, 
        PagoL2 = ${medio.Id}, PagoL2T = '${medio.descripcion}' 
        where idventa = ${venta.idventa}`
        
        let sql4 = `select * from ventasdetail where idproducto = -8 and idventa = ${venta.idventa} and devuelto <> 1`
        let rs = await window.ipcRenderer.invoke('sqlQuery',sql4)
        for (let item of rs) {
          let sql5 = `
          update ventasdetail set devuelto = 1 where idventadetail = ${item.Idventadetail};
          INSERT INTO GESTIONARGASTRONOMIA.dbo.ventasDetail
          (idventa, idproducto, monto, estado, cerrado, NombreArticulo, Comentario, cantidad, tiempo, costo, impuestos, preciosimp, ganancia, stockusado, piva, nroOrden, valor1, PagoL2, PagoL2T, mediopago, tipoPago, devuelto, fechadev, pre, FechaAcreditacion, rubroventaespecial, itempagado, noimprimir, importeoriginal, ordenfac, espostre, idmozo, tipocambio, SubFactura, notDiscount, NombreComanda, tipoPlato, invitacion1, invitacion2, invitacion3, invitacion4, adicionales_pagos_str, idvd_rel, observacionsola, STOCKDESCONTADO, STOCKDESCONTADOQ, TIENEINV, isInvitacion, idDescuentoPredefinido, Tip, TopeDescuento)
          VALUES(${venta.idventa}, -8, ${-item.monto}, 1, NULL, N'${item.NombreArticulo}', NULL, 1.0, NULL, 0.0, NULL, 0.0, 0.0, NULL, 21.0, 99, 0.0, ${item.PagoL2}, N'${item.PagoL2T}', N'${item.mediopago}', ${item.tipoPago}, 1, NULL, N'', NULL, 25, NULL, 0, ${-item.monto}, 0, 0, -1, 1.0, 0, 0, N'Pago Partido ', N'P', 0, 0, 0, 0, NULL, NULL, NULL, 0, NULL, 0, 0, 0, 0, 0.0);`
          await window.ipcRenderer.invoke('sqlQuery',sql5)
        }
        //no hacer esto en pago multiple por esta query  Set rs2 = ds.OpenRecordset("select monto, tipopago from ventasdetail where idventa = " & rs!IdVenta & " and (ventasDetail.idproducto=-8 Or ventasDetail.idproducto=-9) and ventasdetail.monto < 0 ")
        //let sql2 = `delete from ventasdetail where idventa = ${venta.idventa} and idproducto = -8;`
        let sql3 = `
          INSERT INTO GESTIONARGASTRONOMIA.dbo.ventasDetail
          (idventa, idproducto, monto, estado, cerrado, NombreArticulo, Comentario, cantidad, tiempo, costo, impuestos, preciosimp, ganancia, stockusado, piva, nroOrden, valor1, PagoL2, PagoL2T, mediopago, tipoPago, devuelto, fechadev, pre, FechaAcreditacion, rubroventaespecial, itempagado, noimprimir, importeoriginal, ordenfac, espostre, idmozo, tipocambio, SubFactura, notDiscount, NombreComanda, tipoPlato, invitacion1, invitacion2, invitacion3, invitacion4, adicionales_pagos_str, idvd_rel, observacionsola, STOCKDESCONTADO, STOCKDESCONTADOQ, TIENEINV, isInvitacion, idDescuentoPredefinido, Tip, TopeDescuento)
          VALUES(${venta.idventa}, -8, -${venta.total}, 1, NULL, N'${medio.descripcion}', NULL, 1.0, NULL, 0.0, NULL, 0.0, 0.0, NULL, 21.0, 99, 0.0, ${medio.Id}, N'${medio.descripcion}', N'${medio.descripcion}', ${medio.tipoL1}, 0, NULL, N'', NULL, 25, NULL, 0, -${venta.total}, 0, 0, -1, 1.0, 0, 0, N'Pago Partido ', N'P', 0, 0, 0, 0, NULL, NULL, NULL, 0, NULL, 0, 0, 0, 0, 0.0);`

        window.ipcRenderer.invoke('sqlQuery',sql + ";" + sql3 + ";").then(() => {
          venta.tipo = medio.tipoL1
          venta.pagoL2 = medio.Id
          venta.pagoL2t = medio.descripcion
          this.loadDetails({item:venta})
        }).catch((err) => {
          alert(err)
        })
      },
      editItem(item) {
        this.venta = item
        this.dialog = true
      },
      currentItems(items) {
        this.itemsVisibles = items
      },
      getSesion() {
        let sql = "select idsesion from sesion where estado = 1"
        return new Promise((resolve,reject) => {
          window.ipcRenderer.invoke('sqlQuery',sql).then((ret) => {
            if (ret.length == 0) reject("Caja Cerrada")
            resolve(ret[0].idsesion)
          }).catch((err) => {
            reject(err)
          })
        })
      },
      getVentas() {
        this.expanded = []
        this.loading = true
        console.log(this.dbventas.mediosPagoGenericos)
        this.dbventas.getVentas(this.idcaja).then((ret) => {
          ret.data.forEach((row) => {
            console.log(row.tipo)
            if (!row.pagoL2t || row.pagoL2t == "-") row.pagoL2t = this.dbventas.mediosPagoGenericos[row.tipo]
            if (!row.nombres && row.FIS_NOMCLI) row.nombres = row.FIS_NOMCLI
            row.fecha = this.$formatDate(row.fecha) + " " + this.$formatTime(row.sf_hora)
            row.anulado = 0
            if (row.estado==3) {
              row.anulado = row.total
              row.total = 0
            } else {
              row.anulado = 0
            }
          })
          this.ventas = ret.data

        }).catch((err) => {
          console.log(err)
          alert(err)
        })
        .finally(() => {
          this.loading = false
        });
      },      
      getMedios() {
        let sql = `SELECT Id, descripcion, tipoL1
        FROM mediosdepagol2  
        where estado = 1 `
        this.$axios.post('recordset/',{query:sql}).then((ret) => {
          this.medios = ret.data
        }).catch((err) => {alert(err)})
        .finally(() => {
          this.loading = false
        });
      },
      loadDetails({item}) {
        this.loading = true
        this.dbventas.loadDetails(item.idventa).then((ret) => {
          this.$set(item, 'detalleVentas', ret.data);
        }).catch((err) => {alert(err)})
        .finally(() => {
          this.loading = false
        })
      },
      clickComanda(item) {
        if (!item.comanda) {
          this.loadComandas(item)
        }
      },          
      loadComandas(item) {
        this.loading = true
        this.dbventas.loadComandas(item.idventa).then((ret) => {
          this.$set(item, 'comandas', ret.data);
        }).catch((err) => {alert(err)})
        .finally(() => {
          this.loading = false
        })
      },      
      excel() {
        this.$excel(this.headers,this.ventas)
      }      
    },
    computed: {
      suma() {
        if (!this.itemsVisibles) return 0;
        return this.$formatNumber(this.itemsVisibles.filter((f) => f.estado!=3).reduce((a, b) => a + b.total, 0));
      }
    }
}


</script>

<style scoped lang="scss">
  .src-components-hello-world {
    .scrooler {
      height: 50vh;
      overflow-y: scroll;
    }
    .tableDetail {
      background-color:"red";
    }
  }
</style>
